<form [formGroup]="pairingForm">
   <select formControlName="ladderId">
      <option *ngFor="let l of ladders" [value]="l.ladderId">{{l.ladderId}} - {{l.name}}</option>
   </select>
   <br />
   <select formControlName="levelId">
      <option *ngFor="let l of levels" [ngValue]="l.id">{{l.nameLong}}</option>
   </select>
   <br />


   <br />
  record any match here
   <br />

</form>

<!--<div *ngIf="result" style="margin-top: 20px;">
   {{result|json}}
</div>-->
